import type { Map } from "mapbox-gl";

// Get the bounding box of the active countries on the map
export const getActiveCountriesBBox = (map: Map): [number, number, number, number] => {
    const center = map?.getCenter();
    const bounds = map?.getBounds();
    const zoom = map?.getZoom();
    const zoomMin = map?.getMinZoom();
    const zoomMax = 11;

    if (!center || !bounds || !zoom || !zoomMin || !zoomMax) return [0, 0, 0, 0];
    // Calculate the bounding box based on the center, zoom level and map bounds
    const zoomFactor = (zoom - zoomMin) / (zoomMax - zoomMin);
    const sizeFactor = Math.pow(2, zoomFactor) * 0.05;

    const halfSideLength = sizeFactor * 100; // sizeFactor in kilometers

    const latOffset = halfSideLength / 110.574; // 1 degree latitude is approximately 110.574 km
    const lngOffset = halfSideLength / (111.32 * Math.cos(center.lat * (Math.PI / 180))); // 1 degree longitude varies based on latitude

    const minLat = Math.max(center.lat - latOffset, bounds.getSouth());
    const maxLat = Math.min(center.lat + latOffset, bounds.getNorth());
    const minLng = Math.max(center.lng - lngOffset, bounds.getWest());
    const maxLng = Math.min(center.lng + lngOffset, bounds.getEast());

    return [minLng, minLat, maxLng, maxLat];
};
